import { render, staticRenderFns } from "./create-building-courtesy.vue?vue&type=template&id=05e5cdd0&scoped=true"
import script from "./create-building-courtesy.vue?vue&type=script&lang=js"
export * from "./create-building-courtesy.vue?vue&type=script&lang=js"
import style0 from "./create-building-courtesy.vue?vue&type=style&index=0&id=05e5cdd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e5cdd0",
  null
  
)

export default component.exports